const translations = {
  // Welcome
  'home.welcome.title': 'Welcome {name}',
  // Sidebar
  // Rewards redeemed
  'home.sidebar.rewards.label': 'Cash Back Balance',
  'home.sidebar.rewards.lifetime': 'Lifetime Cash Back',
  // Monthly contributions
  'home.sidebar.contributions.label': 'Contributed this month',
  // Last donations
  'home.sidebar.donations.label': 'Last donations',
  'home.sidebar.donations.no-data': 'No transactions to show',
  // Link card
  'home.sidebar.link.label': 'Subscribe, Earn Rewards & Boost Our Mission!',
  // Destination
  'home.sidebar.destinations.label': 'You\'re supporting',
  // Hero
  'home.hero.invite.label': 'Invite friends and earn {amount} for each successful referral',
  'home.hero.invite.btn': 'Invite',
  // Rewards
  'home.rewards.featured': 'Featured deals',
  'home.rewards.curated': 'Curated deals for you',
  'home.rewards.discount': 'Tap the best online discounts',
  'home.rewards.get': 'Get deal',
  'home.rewards.cash.back': 'Get cash back from your favourite brands',
  'home.rewards.cash.back.info': 'Turn everyday purchases into life-changing impact, earn amazing rewards, and help the causes you care about.',
  'home.rewards.categories': 'Rewards for any occasion',
  'home.rewards.amazing': 'Select an Amazing Reward',
  'home.rewards.more.btn': 'See more Perks',
  'home.rewards.learn.btn': 'Learn more',
  // Sweepstakes
  'home.sweepstakes.title': 'Monthly member giveaway',
  'home.sweepstakes.tickets.cta': 'Show my numbers',
  'home.sweepstakes.no-cards.cta': 'Subscribe to get entries',
  'home.sweepstakes.no-tickets.cta': 'New numbers will be available before the next draw',
  // Cookies
  'home.cookies.title': 'We value your privacy',
  'home.cookies.subtitle': 'We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking ”Accept All”, you consent to our use of cookies.',
  'home.cookies.link': 'Cookie Policy',
  'home.cookies.reject': 'Reject All',
  'home.cookies.accept': 'Accept All',
};

export default translations;
